export const sidebar = {
  header: {
    menu: "MENU",
  },
  items: {
    home: "Início",
    reservations: "Reservas",
    calendar: "Calendário",
    hourlyCalendar: "Por horas",
    calls: "Chamadas",
    aiReception: "Receção IA",
    availabilityRates: "Disponibilidade e tarifas",
    checkins: "Check-ins",
    channels: "Canais de reserva",
    inbox: "Caixa de entrada",
    settings: "Configurações",
    experiences: "Experiências",
    scheduleCall: "Agendar uma chamada",
    support: "Suporte",
    novedades: "Novidades",
    messages: "Mensagens",
    badgeNew: "Novo",
    invoicing: "Faturamento",
    customers: "Clientes",
    clientsDirectory: "Clientes",
    fiscalCustomers: "Clientes fiscais",
    invoices: "Faturas",
    housekeeping: "Limpeza",
    analytics: "Analytics",
  },
  alt: {
    logo: "Logo",
  },
};
